// 🚨 Pages publiques — erreur honnête selon la cause (404 / 410 / technique) + bouton Réessayer.
export const TITRES_ERREUR_PUBLIQUE = {
  introuvable: (doc) => `${doc} introuvable`,
  retiree: (doc) => `${doc} retirée`,
  lien_remplace: () => 'Lien remplacé',
  technique: () => 'Problème technique temporaire',
};

export function titreErreurPublique(error, doc = 'Document') {
  const code = typeof error === 'object' && error ? error.code : 'introuvable';
  return (TITRES_ERREUR_PUBLIQUE[code] || TITRES_ERREUR_PUBLIQUE.introuvable)(doc);
}

export function ErreurPublique({ error, doc = 'Document', onRetry, children }) {
  const obj = typeof error === 'object' && error ? error : { code: 'introuvable', message: String(error || '') };
  const technique = obj.code === 'technique';
  return (
    <div className="bg-white rounded-xl p-8 text-center shadow-sm max-w-md w-full" data-testid="erreur-publique" data-code={obj.code}>
      <h2 className="text-xl font-semibold text-slate-800 mb-2" data-testid="erreur-publique-titre">{titreErreurPublique(obj, doc)}</h2>
      <p className="text-slate-600" data-testid="erreur-publique-message">{obj.message}</p>
      {technique && onRetry && (
        <button type="button" onClick={onRetry} className="mt-5 px-5 py-2.5 rounded-lg bg-slate-900 text-white text-sm font-medium" data-testid="erreur-publique-reessayer">Réessayer</button>
      )}
      {children}
    </div>
  );
}
